import { FC, useState } from 'react';

export const CustomCurrencyDisplay: FC<any> = ({
	value,
	currency,
	currencyStyle = {},
	showDenomination = true,
}) => {
	if (!currency) return null;
	return (
		<span style={{ display: 'flex', gap: 4, alignItems: 'baseline' }}>
			<span>{currency.symbolFormat(value)}</span>
			{showDenomination ? (
				<span style={currencyStyle} className={'footnoteDescription'}>
					{currency.id}
				</span>
			) : null}
		</span>
	);
};
